import styled from 'styled-components'
import { breakpoints, MediumHeader } from 'src/utils/styles/global-styles'
import { GatsbyImage } from 'gatsby-plugin-image'

export const CalendarSyncsSection = styled.div`
  background-color: ${(props) => props.theme.cream};
  padding: 0px;
  position: relative;
  @media (max-width: ${breakpoints.s}px) {
    padding: 30px 0px 0px;
  }
`
export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  @media (max-width: ${breakpoints.s}px) {
    justify-content: space-between;
    margin-top: 16px;
  }
`
export const Card = styled.div`
  padding: 5px;
`
export const Text = styled.h3`
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color: ${(props) => props.theme.appearance};
  @media (max-width: ${breakpoints.s}px) {
    font-size: 10px;
    line-height: 15px;
    margin-top: 5px;
  }
`
export const Icon = styled(GatsbyImage)`
  width: 50px;
  @media (max-width: 450px) {
    width: 45px;
  }
`
export const Header = styled(MediumHeader)`
  display: block;
  font-family: 'MatterRegular';
  margin-top: 50px;
  margin-bottom: 40px;
  font-size: 18px;
  line-height: 26px;
  @media (max-width: ${breakpoints.m}px) {
    margin-top: 40px;
    margin-bottom: 30px;
    font-size: 16px;
  }
  @media (max-width: ${breakpoints.s}px) {
    max-width: 100%;
    margin: 20px auto;
  }
`
export const CalSyncsContainer = styled.div`
  @media (max-width: ${breakpoints.s}px) {
    padding: 32px 0px 16px;
    max-width: 90%;
    margin: auto;
  }
  @media (max-width: 385px) {
    padding: 40px 0px 16px;
  }
`
